/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Confirm_Checkin_DescInputs */

const en_rental_confirm_checkin_desc = /** @type {(inputs: Rental_Confirm_Checkin_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to confirm you have checked in. This releases payment to the host.`)
};

const es_rental_confirm_checkin_desc = /** @type {(inputs: Rental_Confirm_Checkin_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca para confirmar que has hecho el check-in. Esto libera el pago al anfitrión.`)
};

const fr_rental_confirm_checkin_desc = /** @type {(inputs: Rental_Confirm_Checkin_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appuyez pour confirmer que vous êtes bien arrivé. Cela débloque le paiement pour l'hôte.`)
};

const de_rental_confirm_checkin_desc = /** @type {(inputs: Rental_Confirm_Checkin_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippe, um zu bestätigen, dass du eingecheckt hast. Dadurch wird die Zahlung an den Gastgeber freigegeben.`)
};

const id_rental_confirm_checkin_desc = /** @type {(inputs: Rental_Confirm_Checkin_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketuk untuk mengonfirmasi bahwa Anda telah check-in. Ini melepaskan pembayaran ke tuan rumah.`)
};

/** @type {(inputs: Rental_Confirm_Checkin_DescInputs) => LocalizedString} */
const ja_rental_confirm_checkin_desc = en_rental_confirm_checkin_desc;

/** @type {(inputs: Rental_Confirm_Checkin_DescInputs) => LocalizedString} */
const zh_rental_confirm_checkin_desc = en_rental_confirm_checkin_desc;

/** @type {(inputs: Rental_Confirm_Checkin_DescInputs) => LocalizedString} */
const ar_rental_confirm_checkin_desc = en_rental_confirm_checkin_desc;

/** @type {(inputs: Rental_Confirm_Checkin_DescInputs) => LocalizedString} */
const it_rental_confirm_checkin_desc = en_rental_confirm_checkin_desc;

/** @type {(inputs: Rental_Confirm_Checkin_DescInputs) => LocalizedString} */
const ru_rental_confirm_checkin_desc = en_rental_confirm_checkin_desc;

/** @type {(inputs: Rental_Confirm_Checkin_DescInputs) => LocalizedString} */
const pt_rental_confirm_checkin_desc = en_rental_confirm_checkin_desc;

/** @type {(inputs: Rental_Confirm_Checkin_DescInputs) => LocalizedString} */
const ko_rental_confirm_checkin_desc = en_rental_confirm_checkin_desc;

/**
* | output |
* | --- |
* | "Tap to confirm you have checked in. This releases payment to the host." |
*
* @param {Rental_Confirm_Checkin_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_confirm_checkin_desc = /** @type {((inputs?: Rental_Confirm_Checkin_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Confirm_Checkin_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_confirm_checkin_desc(inputs)
	if (locale === "es") return es_rental_confirm_checkin_desc(inputs)
	if (locale === "fr") return fr_rental_confirm_checkin_desc(inputs)
	if (locale === "de") return de_rental_confirm_checkin_desc(inputs)
	if (locale === "ja") return ja_rental_confirm_checkin_desc(inputs)
	if (locale === "zh") return zh_rental_confirm_checkin_desc(inputs)
	if (locale === "ar") return ar_rental_confirm_checkin_desc(inputs)
	if (locale === "id") return id_rental_confirm_checkin_desc(inputs)
	if (locale === "it") return it_rental_confirm_checkin_desc(inputs)
	if (locale === "ru") return ru_rental_confirm_checkin_desc(inputs)
	if (locale === "pt") return pt_rental_confirm_checkin_desc(inputs)
	return ko_rental_confirm_checkin_desc(inputs)
});